<script context="module" lang="ts">
	import Section from '$lib/components/layout/Section.svelte';
	import type { SectionConfig } from '$lib/util/pagebuilder';
	import { gql } from 'graphql-request';

	export const config: SectionConfig = {
		collection: 'section_text',
		availableFor: ['posts'],
		query: gql`
			translations {
        languages_code {
          code
        }
				text
			}
    `
	};
	type Props = {
		text: string;
	};
</script>

<script lang="ts">
	import Wysiwyg from '$lib/components/inputs/WYSIWYG.svelte';

	export let data: Props; // the components gets all data via this prop (additionally each top level prop is directly provided to the component)
</script>

<Section gapType="margin" class="section-blog-text" type="slim">
	<div class="wrapper">
		<Wysiwyg text={data?.text} />
	</div>
</Section>

<style lang="scss">
	.wrapper {
		@include font(text);

		:global(h2) {
			@include font(h2);
			margin-bottom: v(content-padding);
		}

		:global(h3) {
			@include font(h3);
			margin-bottom: v(content-padding-sm);
		}

		:global(p) {
			margin-bottom: 16px;
			@include font(text-lg);
		}

		:global(strong) {
			font-weight: 600;
		}

		:global(blockquote) {
			text-align: center;
		}
	}
</style>
